module.exports = __webpack_public_path__ + "img/empty-md-task.png?d53790d6";